/*
 * @Descripttion: 开票申请详情
 * @Author: renbh
 * @Date: 2023-02-02 13:51:00
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-27 15:24:28
 */

import { Col, Row, Space, Tooltip } from 'antd'
import { CopyOutlined } from '@ant-design/icons'
import useInvoiceApplicationDetailHook from './hooks'
import style from './style.module.scss'
import TableAntd from '../../components/TableAntd'
import DownloadIcon from '../../assets/img/download.png'
import { fileFile } from '../../modules/uploadfiles/hooks'
import InvoiceOrderInfo from '../../modules/invoiceOrderInfo'
import moment from 'moment'
import { invoicingState, invoicingType } from '../../tools/util'
import PreviewModal from '../../components/previewModal'

export default function InvoiceApplicationDetail() {
  const {
    hookstate,
    onCopy,
    onPackageDownload,
    showPreviewModal,
    cancelPreviewModal,
  } = useInvoiceApplicationDetailHook()
  const {
    invoiceInfoData,
    invoicingInfo,
    orderData,
    materialData,
    invoiceType,
    isPreviewModalVisible,
    previewFileUrl,
    routeParams,
  } = hookstate

  // 发票信息表格
  const invoiceListColumn = [
    {
      key: 'invoiceNum',
      dataIndex: 'invoiceNum',
      title: '发票号',
      render: (text: any) => text || '-',
      width: 150,
    },
    {
      key: 'invoiceCode',
      dataIndex: 'invoiceCode',
      title: '发票代码',
      render: (text: any) => text || '-',
      width: 150,
    },
    {
      key: 'openTime',
      dataIndex: 'openTime',
      title: '开票日期',
      render: (text: any) => (text ? moment(text).format('YYYY-MM-DD') : '-'),
      width: 150,
    },
    {
      key: 'taxPrice',
      dataIndex: 'taxPrice',
      title: '含税金额',
      render: (text: any) => text || '-',
      width: 150,
    },
    {
      key: 'logisticsCompany',
      dataIndex: 'logisticsCompany',
      title: '物流公司',
      render: (text: any) => text || '-',
      width: 150,
    },
    {
      key: 'logisticsNum',
      dataIndex: 'logisticsNum',
      title: '快递单号',
      render: (text: any) => text || '-',
      width: 150,
    },
    {
      key: 'fileDTO',
      dataIndex: 'fileDTO',
      title: '发票附件',
      render: (text: fileFile[]) => (
        <Space align="center" size={4}>
          {text.map((item, index) => (
            <span key={index}>
              {index > 0 ? <span style={{ marginRight: '4px' }}>,</span> : null}
              <span
                className="primaryBtn"
                onClick={() => showPreviewModal(item.baseUrl + item.url)}
              >
                附件{index + 1}
              </span>
            </span>
          ))}
          <Tooltip title="下载发票" getPopupContainer={() => document.body}>
            <img
              src={DownloadIcon}
              alt=""
              style={{
                margin: '8px 0',
                cursor: 'pointer',
                width: '20px',
                maxWidth: '20px',
              }}
              onClick={() => onPackageDownload(text)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ]

  return (
    <div className={style['wrapper']}>
      <main className={style['main']}>
        <div className={style['box']}>
          <InvoiceOrderInfo materialData={materialData} orderData={orderData} />
          <span className={style['invoice-no']}>
            开票申请单号：{routeParams.applicationNumber}
          </span>
        </div>
        {invoiceType === '1' && (
          <div className={style['box']}>
            <div className={style['box-title']}>
              <p className={style['title']}>发票信息</p>
            </div>
            <div className={style['box-content']}>
              <TableAntd
                dataSource={invoiceInfoData}
                loading={false}
                listColumn={invoiceListColumn}
                selfAdaptScroll
              />
            </div>
          </div>
        )}
        <div className={style['box']}>
          <div className={style['box-title']}>
            <p className={style['title']}>开票信息</p>
            <p
              className="primaryBtn"
              style={{ fontSize: '14px' }}
              onClick={() => onCopy('invoice')}
            >
              <CopyOutlined />
              点我复制发票抬头
            </p>
          </div>
          <div className={style['box-content']}>
            <Row>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>发票类型:</div>
                  <div className={style['item-content']}>
                    {
                      invoicingType.find(
                        (item) =>
                          item.value === invoicingInfo?.orderInvoiceEnums,
                      )?.name
                    }
                  </div>
                </div>
              </Col>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>发票抬头:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.title}
                  </div>
                </div>
              </Col>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>税号:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.taxNumber}
                  </div>
                </div>
              </Col>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>开户银行:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.bankName}
                  </div>
                </div>
              </Col>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>银行账户:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.bankAccount}
                  </div>
                </div>
              </Col>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>电话:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.mobile}
                  </div>
                </div>
              </Col>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>地址:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.address}
                  </div>
                </div>
              </Col>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>发票备注信息:</div>
                  <div className={style['item-content']}>
                    <Tooltip title={invoicingInfo?.content}>
                      <div
                        style={{
                          maxWidth: '450px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {invoicingInfo?.content}
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div className={style['box']}>
          <div className={style['box-title']}>
            <p className={style['title']}>其他信息</p>
            <p
              className="primaryBtn"
              style={{ fontSize: '14px' }}
              onClick={() => onCopy('address')}
            >
              <CopyOutlined />
              点我复制收件地址
            </p>
          </div>
          <div className={style['box-content']}>
            <Row>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>邮箱:</div>
                  <div className={style['item-content']}>
                    <Tooltip title={invoicingInfo?.mail}>
                      <div
                        style={{
                          maxWidth: '300px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {invoicingInfo?.mail}
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </Col>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>收件人:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.receiveMan}
                  </div>
                </div>
              </Col>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>联系电话:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.receiveMobile}
                  </div>
                </div>
              </Col>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>收件地址:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.receiveAddress}
                  </div>
                </div>
              </Col>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>其他备注:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.remark}
                  </div>
                </div>
              </Col>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>附件:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.fileList.map((item, index) => (
                      <>
                        {index > 0 && (
                          <span
                            style={{
                              color: '#3c44d3',
                              fontSize: '14px',
                            }}
                          >
                            ，
                          </span>
                        )}
                        <span
                          className="primaryBtn"
                          style={{
                            textDecoration: 'underline',
                            fontSize: '14px',
                          }}
                          onClick={() =>
                            showPreviewModal(`${item.baseUrl}${item.url}`)
                          }
                        >
                          {item.name}
                        </span>
                      </>
                    ))}
                    {invoicingInfo && invoicingInfo.fileList.length > 0 && (
                      <Tooltip title="打包下载">
                        <img
                          src={DownloadIcon}
                          alt=""
                          style={{
                            cursor: 'pointer',
                            marginLeft: '16px',
                            width: '20px',
                            maxWidth: '20px',
                          }}
                          onClick={() =>
                            onPackageDownload(invoicingInfo.fileList)
                          }
                        />
                      </Tooltip>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </main>
      <footer className={style['foot']}>
        <p>
          开票状态：
          {invoicingState
            .filter((item) => item.value === invoiceType)
            .map((item, index) => (
              <span key={index} style={{ color: item.color }}>
                {item.name}
              </span>
            ))}
        </p>
      </footer>
      <PreviewModal
        open={isPreviewModalVisible}
        fileUrl={previewFileUrl}
        onCancel={cancelPreviewModal}
      />
    </div>
  )
}
/*
 * @Descripttion: 开票申请详情
 * @Author: renbh
 * @Date: 2023-02-02 13:51:00
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-27 15:24:28
 */

import { Col, Row, Space, Tooltip } from 'antd'
import { CopyOutlined } from '@ant-design/icons'
import useInvoiceApplicationDetailHook from './hooks'
import style from './style.module.scss'
import TableAntd from '../../components/TableAntd'
import DownloadIcon from '../../assets/img/download.png'
import { fileFile } from '../../modules/uploadfiles/hooks'
import InvoiceOrderInfo from '../../modules/invoiceOrderInfo'
import moment from 'moment'
import { invoicingState, invoicingType } from '../../tools/util'
import PreviewModal from '../../components/previewModal'

export default function InvoiceApplicationDetail() {
  const {
    hookstate,
    onCopy,
    onPackageDownload,
    showPreviewModal,
    cancelPreviewModal,
  } = useInvoiceApplicationDetailHook()
  const {
    invoiceInfoData,
    invoicingInfo,
    orderData,
    materialData,
    invoiceType,
    isPreviewModalVisible,
    previewFileUrl,
    routeParams,
  } = hookstate

  // 发票信息表格
  const invoiceListColumn = [
    {
      key: 'invoiceNum',
      dataIndex: 'invoiceNum',
      title: '发票号',
      render: (text: any) => text || '-',
      width: 150,
    },
    {
      key: 'invoiceCode',
      dataIndex: 'invoiceCode',
      title: '发票代码',
      render: (text: any) => text || '-',
      width: 150,
    },
    {
      key: 'openTime',
      dataIndex: 'openTime',
      title: '开票日期',
      render: (text: any) => (text ? moment(text).format('YYYY-MM-DD') : '-'),
      width: 150,
    },
    {
      key: 'taxPrice',
      dataIndex: 'taxPrice',
      title: '含税金额',
      render: (text: any) => text || '-',
      width: 150,
    },
    {
      key: 'logisticsCompany',
      dataIndex: 'logisticsCompany',
      title: '物流公司',
      render: (text: any) => text || '-',
      width: 150,
    },
    {
      key: 'logisticsNum',
      dataIndex: 'logisticsNum',
      title: '快递单号',
      render: (text: any) => text || '-',
      width: 150,
    },
    {
      key: 'fileDTO',
      dataIndex: 'fileDTO',
      title: '发票附件',
      render: (text: fileFile[]) => (
        <Space align="center" size={4}>
          {text.map((item, index) => (
            <span key={index}>
              {index > 0 ? <span style={{ marginRight: '4px' }}>,</span> : null}
              <span
                className="primaryBtn"
                onClick={() => showPreviewModal(item.baseUrl + item.url)}
              >
                附件{index + 1}
              </span>
            </span>
          ))}
          <Tooltip title="下载发票" getPopupContainer={() => document.body}>
            <img
              src={DownloadIcon}
              alt=""
              style={{
                margin: '8px 0',
                cursor: 'pointer',
                width: '20px',
                maxWidth: '20px',
              }}
              onClick={() => onPackageDownload(text)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ]

  return (
    <div className={style['wrapper']}>
      <main className={style['main']}>
        <div className={style['box']}>
          <InvoiceOrderInfo materialData={materialData} orderData={orderData} />
          <span className={style['invoice-no']}>
            开票申请单号：{routeParams.applicationNumber}
          </span>
        </div>
        {invoiceType === '1' && (
          <div className={style['box']}>
            <div className={style['box-title']}>
              <p className={style['title']}>发票信息</p>
            </div>
            <div className={style['box-content']}>
              <TableAntd
                dataSource={invoiceInfoData}
                loading={false}
                listColumn={invoiceListColumn}
                selfAdaptScroll
              />
            </div>
          </div>
        )}
        <div className={style['box']}>
          <div className={style['box-title']}>
            <p className={style['title']}>开票信息</p>
            <p
              className="primaryBtn"
              style={{ fontSize: '14px' }}
              onClick={() => onCopy('invoice')}
            >
              <CopyOutlined />
              点我复制发票抬头
            </p>
          </div>
          <div className={style['box-content']}>
            <Row>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>发票类型:</div>
                  <div className={style['item-content']}>
                    {
                      invoicingType.find(
                        (item) =>
                          item.value === invoicingInfo?.orderInvoiceEnums,
                      )?.name
                    }
                  </div>
                </div>
              </Col>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>发票抬头:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.title}
                  </div>
                </div>
              </Col>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>税号:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.taxNumber}
                  </div>
                </div>
              </Col>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>开户银行:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.bankName}
                  </div>
                </div>
              </Col>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>银行账户:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.bankAccount}
                  </div>
                </div>
              </Col>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>电话:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.mobile}
                  </div>
                </div>
              </Col>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>地址:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.address}
                  </div>
                </div>
              </Col>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>发票备注信息:</div>
                  <div className={style['item-content']}>
                    <Tooltip title={invoicingInfo?.content}>
                      <div
                        style={{
                          maxWidth: '450px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {invoicingInfo?.content}
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div className={style['box']}>
          <div className={style['box-title']}>
            <p className={style['title']}>其他信息</p>
            <p
              className="primaryBtn"
              style={{ fontSize: '14px' }}
              onClick={() => onCopy('address')}
            >
              <CopyOutlined />
              点我复制收件地址
            </p>
          </div>
          <div className={style['box-content']}>
            <Row>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>邮箱:</div>
                  <div className={style['item-content']}>
                    <Tooltip title={invoicingInfo?.mail}>
                      <div
                        style={{
                          maxWidth: '300px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {invoicingInfo?.mail}
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </Col>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>收件人:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.receiveMan}
                  </div>
                </div>
              </Col>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>联系电话:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.receiveMobile}
                  </div>
                </div>
              </Col>
              <Col span={8}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>收件地址:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.receiveAddress}
                  </div>
                </div>
              </Col>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>其他备注:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.remark}
                  </div>
                </div>
              </Col>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>附件:</div>
                  <div className={style['item-content']}>
                    {invoicingInfo?.fileList.map((item, index) => (
                      <>
                        {index > 0 && (
                          <span
                            style={{
                              color: '#3c44d3',
                              fontSize: '14px',
                            }}
                          >
                            ，
                          </span>
                        )}
                        <span
                          className="primaryBtn"
                          style={{
                            textDecoration: 'underline',
                            fontSize: '14px',
                          }}
                          onClick={() =>
                            showPreviewModal(`${item.baseUrl}${item.url}`)
                          }
                        >
                          {item.name}
                        </span>
                      </>
                    ))}
                    {invoicingInfo && invoicingInfo.fileList.length > 0 && (
                      <Tooltip title="打包下载">
                        <img
                          src={DownloadIcon}
                          alt=""
                          style={{
                            cursor: 'pointer',
                            marginLeft: '16px',
                            width: '20px',
                            maxWidth: '20px',
                          }}
                          onClick={() =>
                            onPackageDownload(invoicingInfo.fileList)
                          }
                        />
                      </Tooltip>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </main>
      <footer className={style['foot']}>
        <p>
          开票状态：
          {invoicingState
            .filter((item) => item.value === invoiceType)
            .map((item, index) => (
              <span key={index} style={{ color: item.color }}>
                {item.name}
              </span>
            ))}
        </p>
      </footer>
      <PreviewModal
        open={isPreviewModalVisible}
        fileUrl={previewFileUrl}
        onCancel={cancelPreviewModal}
      />
    </div>
  )
}
